interface ItemDescriptionProps {
  text: string | null | undefined;
  className?: string;
}

function isHTML(str: string): boolean {
  return /^\s*<[a-z][\s\S]*>/i.test(str.trim());
}

export function ItemDescription({ text, className = '' }: ItemDescriptionProps) {
  if (!text) return null;

  if (isHTML(text)) {
    return (
      <div
        className={`prose prose-sm max-w-none leading-relaxed ${className}`}
        dangerouslySetInnerHTML={{ __html: text }}
        style={{ wordBreak: 'break-word' }}
      />
    );
  }

  return (
    <p className={`whitespace-pre-line leading-relaxed ${className}`}>{text}</p>
  );
}

export default ItemDescription;
